import { Address } from '../../address.model';

export interface Candidate {
    id: string;
    gender: string;
    name: string;
    surname: string;
    title: string;
    birthDate: string;
    email: string;
    telephoneNumber: string;
    address: Address;
}
